"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var react_select_1 = __importStar(require("react-select"));
var SwitchAccount_module_css_1 = __importDefault(require("./SwitchAccount.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var SwitchAccount = function (props) {
    var page = (0, useTypedPage_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: false }).t;
    var _a = (0, react_1.useState)([]), accounts = _a[0], setAccounts = _a[1];
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accountsResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getAccountsForUserByUserId(page.props.user.id)];
                    case 1:
                        accountsResponse = _a.sent();
                        setAccounts(accountsResponse.map(function (account) { return ({
                            label: "".concat(account.name, " (").concat(account.id, ")"),
                            value: account
                        }); }));
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var onChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            localStorage.removeItem("breadcrumb");
            localStorage.removeItem("selectedFolderId");
            localStorage.removeItem("selectedFolderName");
            localStorage.removeItem("folderCollectionNames");
            window.location.replace("/dashboard?account-switch=" + e.value.id);
            return [2 /*return*/];
        });
    }); };
    var customStyles = {
        container: function (styles) { return (__assign(__assign({}, styles), { position: "relative", boxSizing: "border-box", width: "191px", whiteSpace: "nowrap" })); },
        placeholder: function (styles) { return (__assign(__assign({}, styles), { marginLeft: "32px", fontSize: "14px", color: "var(--info-color)" })); },
        input: function (styles) { return (__assign(__assign({}, styles), { marginLeft: "32px", fontSize: "14px", color: "var(--info-color)" })); },
        control: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: "white", border: "none", boxShadow: "none", borderRadius: "unset", borderTopLeftRadius: "14px", borderTopRightRadius: "14px", borderBottom: "2px solid #D2D2D2", fontFamily: "Geomanist", marginBottom: "7px", minHeight: "39px", "&:hover": { borderBottom: "2px solid #D2D2D2" } })); },
        option: function (styles, _a) {
            var isFocused = _a.isFocused;
            return __assign(__assign({}, styles), { backgroundColor: "white", border: "none", color: "var(--info-color)", fontSize: "14px", padding: "15px 15px 0.5rem 1.25rem", textDecoration: "none", fontWeight: isFocused ? "bold" : "normal", cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", fontFamily: "Geomanist" });
        },
        menuList: function (styles) { return (__assign(__assign({}, styles), { paddingTop: "0px", paddingBottom: "unset", borderBottomLeftRadius: "14px", borderBottomRightRadius: "14px" })); },
        dropdownIndicator: function () { return ({
            background: "#F5F9EB",
            marginRight: "15px",
            height: "15px",
            width: "15px",
            borderRadius: "50%",
            fontSize: "8px",
            cursor: "pointer",
        }); },
        indicatorSeparator: function () { return ({ display: "none" }); },
        menu: function () { return ({ border: "2px", overflow: "hidden" }); }
    };
    var DropdownIndicator = function (props) {
        return (react_1.default.createElement("div", { onClick: restoreDropdown },
            react_1.default.createElement(react_select_1.components.DropdownIndicator, __assign({}, props, { className: "d-flex align-items-center justify-content-center" }),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark, size: "1x", color: "var(--info-color)" }))));
    };
    var Option = function (props) {
        return (react_1.default.createElement(react_select_1.components.Option, __assign({}, props),
            page.props.session.current_account.name == props.data.label ?
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, size: "1x", color: "var(--primary-color)", style: { marginRight: "10px" } })
                :
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, size: "1x", color: "transparent", style: { marginRight: "10px" } }),
            props.data.label));
    };
    function restoreDropdown() {
        var selectDropdown = document.getElementById("selectDropdown");
        var mainDropdown = document.getElementById("mainDropdown");
        if (selectDropdown.style.display === "initial") {
            selectDropdown.style.display = "none";
            mainDropdown.style.display = "initial";
            props.setShowingNavigationDropdown(!props.setShowingNavigationDropdown);
        }
    }
    return (react_1.default.createElement("div", { id: "selectDropdown", style: { display: "initial" } },
        react_1.default.createElement(Label_1.default, { className: SwitchAccount_module_css_1.default.label, htmlFor: "account" }, t("Account")),
        react_1.default.createElement(react_select_1.default, { styles: customStyles, options: accounts, menuIsOpen: true, autoFocus: true, onChange: function (e) { return onChange(e); }, components: { DropdownIndicator: DropdownIndicator, Option: Option }, placeholder: t(""), value: t("Switch account"), noOptionsMessage: function () { return t("No options"); } })));
};
exports.default = SwitchAccount;
